import {
	OrderGridTable,
	OrderStatus,
	OrderTime,
	OrderVisitDate,
	selectOrdersByPerson,
	selectOrdersByPersonError,
	selectOrdersByPersonLoader,
	useOrderInfo,
} from 'entities/orders';
import { FC, Fragment, useEffect, useState } from 'react';
import { SECONDARY_BG_COLOR } from 'shared/consts';
import { useAppSelector } from 'shared/lib/store';
import { BasicCard } from 'shared/ui/cards/basicCard';
import { GridRows } from 'shared/ui/gridTable';
import { Typography, withTypographyContainer } from 'shared/ui/typography';

interface PersonVisitOrdersProps {
	title?: string;
  isContinueBooking?: boolean;
}

export const PersonVisitOrders: FC<PersonVisitOrdersProps> = ({ 
  title,
  isContinueBooking = false
}) => {
  const Title = withTypographyContainer(Typography);

	const orders = useAppSelector(selectOrdersByPerson);
	const loader = useAppSelector(selectOrdersByPersonLoader);
	const [rows, setRows] = useState<GridRows[]>([]);
	const error = useAppSelector(selectOrdersByPersonError);

	const { open, setSelectedInfoId, setSelectedId, isOpen } = useOrderInfo();

	const [currentRowId, setCurrentRowId] = useState<number | undefined>(
		undefined,
	);

	const selectOrder = (id: number) => {
		open();
		setCurrentRowId(id);
    isContinueBooking ? setSelectedInfoId(id) : setSelectedId(id);
	};

	useEffect(() => {
		if (!isOpen) {
			setCurrentRowId(undefined);
		}

	}, [isOpen])

	useEffect(() => {
		if (orders.length) {
			const ordersMap = orders.map(order => {
				return {
					id: order.id,
					fields: [
						<OrderVisitDate
							order={order}
							includeCalendarIcon={true}
						/>,
						<OrderTime order={order} />,
						<OrderStatus order={order} />,
					],
				};
			});

			setRows([{ rows: [{ cells: ordersMap }] }]);
		}
	}, [orders]);

	return (
		<Fragment>
			{title && <Title mode="small">{title}</Title>}
			<BasicCard styles={{ padding: '8px 8px 8px 12px' }}>
				<OrderGridTable
					isLoading={loader}
					tableRows={rows}
					columnCount={3}
					error={error}
					selectOrder={selectOrder}
					currentRowId={currentRowId}
					gridSettings={{
						columnSize: 6,
					}}
					specificColumnSizes={[{ index: 1, size: 5 }]}
					gridStyles={{
						rowsHeight: '300px',
						rowsPadding: '16px',
						rowCardColor: SECONDARY_BG_COLOR,
						rowPadding: '6px 16px',
						rowMargin: '8px',
						rowCorners: '24px',
					}}
					notFoundText="Визиты не найдены"
				/>
			</BasicCard>
		</Fragment>
	);
};
